module.exports = __webpack_public_path__ + "media/categories/4101-b3db0817.svg";